import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DropdownArrow } from '~/styles/dropdownStyles';

interface NotificationFilterDropdownProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * The eleven kinds legacy lets a reader filter by, plus View All.
 *
 * In legacy only BuddyBoss's own actions and the Study Helper Announcement
 * register a filter; the WBS notification types don't.
 */
export function NotificationFilterDropdown({
  value,
  onChange,
}: NotificationFilterDropdownProps) {
  const { t } = useTranslation();

  return (
    <ViewDropdownWrapper>
      <ViewDropdown value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="0">{t('wbs.view-all')}</option>
        <option value="new_at_mention">{t('wbs.new-mentions')}</option>
        <option value="update_reply">{t('wbs.new-update-replies')}</option>
        <option value="comment_reply">
          {t('forum.new-update-comment-replies')}
        </option>
        <option value="new_membership_request">
          {t('profile.pending-group-membership-requests')}
        </option>
        <option value="membership_request_accepted">
          {t('profile.accepted-group-membership-requests')}
        </option>
        <option value="membership_request_rejected">
          {t('profile.rejected-group-membership-requests')}
        </option>
        <option value="member_promoted_to_admin">
          {t('groups.group-organizer-promotions')}
        </option>
        <option value="member_promoted_to_mod">
          {t('groups.group-moderator-promotions')}
        </option>
        <option value="new_study_helper_announcement">
          {t('lessons.study-helper-announcement')}
        </option>
        <option value="group_invite">{t('groups.group-invitations')}</option>
        <option value="new_message">{t('wbs.new-private-messages')}</option>
      </ViewDropdown>
      <DropdownArrow>
        <FontAwesomeIcon icon={faChevronDown} />
      </DropdownArrow>
    </ViewDropdownWrapper>
  );
}

const ViewDropdownWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const ViewDropdown = styled.select`
  appearance: none;
  background: var(--white);
  border: 0;
  border-radius: 5px;
  box-shadow: var(--shadow-inset-lg);
  color: var(--black);
  font-family: var(--raleway);
  font-size: 13px;
  font-weight: 400;
  outline: none;
  padding: 9px 12px;
  width: 275px;
`;
